import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminDashboardRoute extends Route {
  // Services
  @service store;
  @service fetch;
  @service intl;

  // Hooks
  async model() {
    const locale = this.intl.primaryLocale;

    const [{ content: deContent }, { content: enContent }, activities] =
      await Promise.all([
        this.store.request(findRecord('mlp', '1055')),
        this.store.request(findRecord('mlp', '2763')),
        this.fetch.request('/userActivities'),
      ]);

    const deDashboard = deContent.data;
    const enDashboard = enContent.data;

    const vhost = await deDashboard.vhost;

    return {
      mlp: locale === 'de' ? deDashboard : enDashboard,
      domain: `${vhost?.firstDomainName}${locale === 'de' ? '' : '/en'}`,
      activities: activities?.user?.activityFeed ?? [],
    };
  }
}
